import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { chgInstance } from "../../redux/ReduxInstance";
import { Container, Form, Button, Image } from "react-bootstrap";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ComponentLoader from "../../components/layout/ComponentLoader";
import { apiGetInstance, apiUpdateInstance } from "../../api/ApiInstance";
import { MdZoomIn, MdZoomOut } from "react-icons/md";
//https://www.npmjs.com/package/react-avatar-editor
import AvatarEditor from "react-avatar-editor";
import { useTranslation } from "react-i18next";

const PageAdminInstance = () => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    entite: "",
    couleur: "",
    theme: false,
    phraseAccroche: "",
    urlReservationSalle: "",
    modulesActives: [],
    logoPic: "",
    logoMenuPic: "",
  });
  // eslint-disable-next-line no-unused-vars
  const [modules, setModules] = useState([
    { label: t("admin.PageAdminInstance.modules.label1"), module: "accueil1" },
    { label: t("admin.PageAdminInstance.modules.label2"), module: "accueil2" },
    { label: t("admin.PageAdminInstance.modules.label3"), module: "accueil3" },
    { label: t("admin.PageAdminInstance.modules.label4"), module: "accueil4" },
    {
      label: t("admin.PageAdminInstance.modules.label5"),
      module: "visualmanagement",
    },
    {
      label: t("admin.PageAdminInstance.modules.label6"),
      module: "evenement",
    },
    { label: t("admin.PageAdminInstance.modules.label7"), module: "actualite" },
    { label: t("admin.PageAdminInstance.modules.label8"), module: "emission" },
    {
      label: t("admin.PageAdminInstance.modules.label9"),
      module: "publication",
    },
  ]);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const [zoomAccueil, setZoomAccueil] = useState(1.1);
  const [zoomMenu, setZoomMenu] = useState(1.1);
  const [picAccueilFileInput, setPicAccueilFileInput] = useState();
  const [editorPicAccueil, setEditorPicAccueil] = useState();
  const [modeEditPicAccueil, setModeEditPicAccueil] = useState(false);
  const [modeDeletePicAccueil, setModeDeletePicAccueil] = useState(false);

  const [picMenuFileInput, setPicMenuFileInput] = useState();
  const [editorPicMenu, setEditorPicMenu] = useState();
  const [modeEditPicMenu, setModeEditPicMenu] = useState(false);
  const [modeDeletePicMenu, setModeDeletePicMenu] = useState(false);

  const handleAddModule = (leModule) => {
    const newModules = [...state.modulesActives];
    newModules.push(leModule);
    setState({ ...state, modulesActives: newModules });
  };

  const handleRemoveModule = (leModule) => {
    const modulesActivesCopy = [...state.modulesActives];
    const newModules = modulesActivesCopy.filter((item) => item !== leModule);
    setState({ ...state, modulesActives: newModules });
  };

  const submitData = async (e) => {
    setLoader(true);
    e.preventDefault();

    var formdata = new FormData();

    for (var key in state) {
      if (key === "modulesActives") {
        state[key].forEach((element) => {
          formdata.append(key + "[]", element);
        });
      } else if (key === "logoPic" || key === "logoMenuPic") {
        if (key === "logoPic") {
          if (modeDeletePicAccueil) {
            formdata.append(key, "");
          } else {
            formdata.append(key, state[key]);
          }
        }
        if (key === "logoMenuPic") {
          if (modeDeletePicMenu) {
            formdata.append(key, "");
          } else {
            formdata.append(key, state[key]);
          }
        }
      } else {
        formdata.append(key, state[key]);
      }
    }

    /* traitement image */
    if (picAccueilFileInput) {
      let imgBase64 = "";
      imgBase64 = editorPicAccueil.getImageScaledToCanvas().toDataURL();
      var blobBin = atob(imgBase64.split(",")[1]);
      var array = [];
      for (var i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
      }
      var file = new Blob([new Uint8Array(array)], { type: "image/png" });
      formdata.append("logoPic", file);
    }
    /* fin traitement image */

    /* traitement image */
    if (picMenuFileInput) {
      let imgBase64Menu = "";
      imgBase64Menu = editorPicMenu.getImageScaledToCanvas().toDataURL();
      var blobBinMenu = atob(imgBase64Menu.split(",")[1]);
      var array = [];
      for (var j = 0; j < blobBinMenu.length; j++) {
        array.push(blobBinMenu.charCodeAt(j));
      }
      var fileMenu = new Blob([new Uint8Array(array)], { type: "image/png" });
      formdata.append("logoMenuPic", fileMenu);
    }
    /* fin traitement image */

    await apiUpdateInstance(ReduxInstance._id, formdata);
    const res = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
    setPicAccueilFileInput("");
    setModeEditPicAccueil(false);
    setModeDeletePicAccueil(false);
    setPicMenuFileInput("");
    setModeEditPicMenu(false);
    setModeDeletePicMenu(false);
    dispatch(chgInstance(res.data));
    setLoader(false);
  };

  useEffect(() => {
    setState({
      entite: ReduxInstance.entite,
      couleur: ReduxInstance.couleur,
      theme: ReduxInstance.theme,
      logoPic: ReduxInstance.logoPic,
      logoMenuPic: ReduxInstance.logoMenuPic,
      phraseAccroche: ReduxInstance.phraseAccroche,
      urlReservationSalle: ReduxInstance.urlReservationSalle,
      modulesActives: ReduxInstance.modulesActives,
    });
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminInstance.titre")} />
        <Form onSubmit={submitData}>
          <label className="fw-bold">{t("commun.form.label.intitule1")}</label>
          <Form.Control
            type="text"
            name="entite"
            className="mb-3"
            value={state.entite}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />

          <label className="fw-bold">{t("commun.form.label.intitule2")}</label>
          <div className="d-flex">
            <Form.Control
              name="couleur"
              type="color"
              value={state.couleur ? state.couleur : "#000000"}
              className="mb-3"
              onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
            />
            <Form.Control
              type="text"
              name="couleur"
              className="mb-3"
              value={state.couleur ? state.couleur : "#000000"}
              onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
            />
          </div>
          <label className="fw-bold">{t("commun.form.label.intitule3")}</label>
          <div className="d-flex ">
            <span>{t("commun.colors.noir")}</span>
            <div className="ms-2 me-2">
              <Form.Check
                name="theme"
                type="switch"
                value={state.theme}
                onChange={(e) => setState({ ...state, [e.target.name]: !state.theme })}
                checked={!state.theme ? "" : "checked"}
              />
            </div>
            <span>{t("commun.colors.blanc")}</span>
          </div>
          <hr />
          <label className="fw-bold">{t("commun.form.label.intitule4")}</label>
          {(!state.logoMenuPic || modeEditPicMenu || modeDeletePicMenu) && (
            <div className="mb-3">
              <Form.Control type="file" onChange={(e) => setPicMenuFileInput(e.target.files[0])} />
              {(modeEditPicMenu || modeDeletePicMenu) && !picMenuFileInput && (
                <Button
                  onClick={(e) => {
                    setPicMenuFileInput("");
                    setModeEditPicMenu(false);
                    setModeDeletePicMenu(false);
                  }}
                  variant="danger"
                  className="mt-1"
                >
                  {t("commun.form.button.annuler")}
                </Button>
              )}
            </div>
          )}

          {state.logoMenuPic && !modeEditPicMenu && !modeDeletePicMenu && (
            <div>
              <Image
                src={process.env.REACT_APP_URL_EXPRESS + "images/instance/" + state.logoMenuPic}
              />
              <div className="mt-2 d-flex">
                <Button className="me-1 " onClick={(e) => setModeEditPicMenu(true)}>
                  Modifier
                </Button>
                <Button variant="danger" onClick={(e) => setModeDeletePicMenu(true)}>
                  Supprimer
                </Button>
              </div>
            </div>
          )}

          {picMenuFileInput && (
            <div>
              <div>
                <AvatarEditor
                  image={picMenuFileInput}
                  width={300}
                  height={68}
                  border={20}
                  color={[255, 255, 255, 0.9]}
                  scale={parseFloat(zoomMenu)}
                  rotate={0}
                  ref={setEditorPicMenu}
                />
                <br />
                <MdZoomOut size="3em" />
                <Form.Range
                  onChange={(e) => setZoomMenu(e.target.value)}
                  value={zoomMenu}
                  min="1"
                  max="3"
                  step="0.1"
                  style={{ width: "150px" }}
                />
                <MdZoomIn size="3em" />
              </div>
              <Button
                onClick={(e) => {
                  setPicMenuFileInput("");
                  setModeEditPicMenu(false);
                }}
                variant="danger"
                className="me-2"
              >
                Annuler
              </Button>
            </div>
          )}
          <hr />
          <label className="fw-bold">{t("commun.form.label.intitule5")}</label>
          {(!state.logoPic || modeEditPicAccueil || modeDeletePicAccueil) && (
            <div className="mb-3">
              <Form.Control
                type="file"
                onChange={(e) => setPicAccueilFileInput(e.target.files[0])}
              />
              {(modeEditPicAccueil || modeDeletePicAccueil) && !picAccueilFileInput && (
                <Button
                  onClick={(e) => {
                    setPicAccueilFileInput("");
                    setModeEditPicAccueil(false);
                    setModeDeletePicAccueil(false);
                  }}
                  variant="danger"
                  className="mt-1"
                >
                  Annuler
                </Button>
              )}
            </div>
          )}

          {state.logoPic && !modeEditPicAccueil && !modeDeletePicAccueil && (
            <div>
              <Image src={process.env.REACT_APP_URL_EXPRESS + "images/instance/" + state.logoPic} />
              <div className="mt-2 d-flex">
                <Button className="me-1 " onClick={(e) => setModeEditPicAccueil(true)}>
                  Modifier
                </Button>
                <Button variant="danger" onClick={(e) => setModeDeletePicAccueil(true)}>
                  Supprimer
                </Button>
              </div>
            </div>
          )}

          {picAccueilFileInput && (
            <div>
              <div>
                <AvatarEditor
                  image={picAccueilFileInput}
                  width={170}
                  height={170}
                  border={20}
                  color={[255, 255, 255, 0.9]}
                  scale={parseFloat(zoomAccueil)}
                  rotate={0}
                  ref={setEditorPicAccueil}
                />
                <br />
                <MdZoomOut size="3em" />
                <Form.Range
                  onChange={(e) => setZoomAccueil(e.target.value)}
                  value={zoomAccueil}
                  min="1"
                  max="3"
                  step="0.1"
                  style={{ width: "150px" }}
                />
                <MdZoomIn size="3em" />
              </div>
              <Button
                onClick={(e) => {
                  setPicAccueilFileInput("");
                  setModeEditPicAccueil(false);
                }}
                variant="danger"
                className="me-2"
              >
                Annuler
              </Button>
            </div>
          )}
          <hr />
          <label className="fw-bold mt-5">{t("commun.form.label.intitule6")}</label>
          <Form.Control
            name="phraseAccroche"
            as="textarea"
            className="mb-3"
            rows={3}
            value={state.phraseAccroche}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />

          <label className="fw-bold">{t("commun.form.label.intitule17")}</label>
          <Form.Control
            type="text"
            name="urlReservationSalle"
            className="mb-5"
            value={state.urlReservationSalle}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />

          <label className="fw-bold">{t("commun.form.label.intitule7")}</label>
          <div className="border p-2 mb-2">
            {modules.map((itemModule, index) => (
              <Form.Check
                id={"module" + index}
                key={index}
                type="switch"
                label={itemModule.label}
                onChange={(e) => {
                  state.modulesActives.includes(itemModule.module)
                    ? handleRemoveModule(itemModule.module)
                    : handleAddModule(itemModule.module);
                }}
                checked={state.modulesActives.includes(itemModule.module) ? "checked" : ""}
              />
            ))}
          </div>
          <div className="text-end mb-5">
            {!loader && (
              <Button variant="success" type="Submit">
                {t("commun.form.button.enregistrer")}
              </Button>
            )}
            {loader && <ComponentLoader />}
          </div>
        </Form>
      </Container>
    </>
  );
};

export default PageAdminInstance;
